export const isZohoEnabled = () => {
  return true;
};

export const isTransactionItemsEnabled = () => true;

export const isIncomeStatementEnabled = () =>
  process.env.ENABLE_INCOME_STATEMENT === true;

export const isMultipleLanguagesDisabled = () =>
  process.env.DISABLE_MULTIPLE_LANGUAGES === true;

export const isVatCheckerDisabled = () => false;